import CONFIGURACIONES from "../../../../util/constants";
import OWASP from "../../../../util/owasp";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";

import { Http } from "../../../../helpers/Http";
import { useLocation, useOutletContext } from "react-router-dom";

const MantAgency = ({mant, idEdit, createData, updateData, closeSection, zonas, idRef, setIdRef, endPointShow, setEndPointUpdate, init, showCreate, showEdit}) => {
    const location = useLocation();
    const { showSpinnerLoader } = useOutletContext();

    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm({mode: "onChange"});
    const [title, setTitle] = useState(CONFIGURACIONES.INIT.STRING);

    useEffect(() => {
        reset();
        showSpinnerLoader();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSeg', lastSegment);
        
        if (lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')) {
            init();
            setIdRef((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            showData((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            setTitle((lastSegment === 'new')? `Creando ${mant}`:`Editando ${mant}`);
        }
    }, [location.pathname]);

    const onSubmit1 = (form) => {
        // console.log('form', form);
        if (idRef === CONFIGURACIONES.INIT.ID_EDIT) {
            createData(form);
        } else {
            updateData(form);
        }
    };

    const showData = async (ref) => {
        console.log('ref', ref);
        
        if (ref !== CONFIGURACIONES.INIT.ID_EDIT) {
            console.log('entras...', endPointShow);
            if (endPointShow === CONFIGURACIONES.INIT.STRING || !showEdit) { closeSection(); }
            
            await Http().get(endPointShow)
            .then(async (rpta) => {
                if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                    // setLinks(rpta.data.links);
                    setEndPointUpdate(rpta.data.links.find(link => link.rel === CONFIGURACIONES.REFS.UPDATE)?.href || null);
                    // let cmpLink = rpta.data.links.find(link => link.rel === CONFIGURACIONES.INIT.HREF_LOGS);
                    // console.log('cmpLink', cmpLink);
                    // await loadLogData(cmpLink?.href);
                    loadForm(rpta.data);
                }
            });
        } else {
            if (!showCreate) { closeSection(); }
        }
    };

    const loadForm = (object) => {
        setValue('nombre', object.nombre);
        setValue('zonaId', object.zonaId);
    };

    return (
        <>
        { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
            <div className="card-content">
                <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                    <div className="row">
                        <div className="col-xs-12 col-md-11"> 
                            <h5 className="card-title font-weight-bold">{title}</h5>
                            <div className="row">
                                <div className="col-sm-12 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="nombre" className="control-label col-form-label">Nombre <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("nombre", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="nombre" placeholder="" />
                                        <small className="invalid-feedback"> { errors.nombre && errors.nombre.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="zonaId" className="control-label col-form-label">Zona <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("zonaId", {
                                                required: OWASP.REQUIRED,
                                            })} className="form-control" id="zonaId" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                               
                                            {
                                                zonas.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.zonaId && errors.zonaId.message }</small>           
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                       
                    <div className="action-form mt-1 d-flex justify-content-start">
                        <div className="form-group mb-0 text-left">
                            <WaveButton type="button" onClick={ closeSection } className="btn btn-sm btn-outline-danger waves-effect">
                                <i className="mdi mdi-arrow-left"></i> Descartar
                            </WaveButton>
                            { idRef == CONFIGURACIONES.INIT.ID_EDIT && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Guardar
                            </WaveButton>}

                            { idRef > CONFIGURACIONES.INIT.NUMBER && <WaveButton type="submit" className="btn btn-sm btn-info waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Modificar
                            </WaveButton>}
                        </div>
                    </div>
                </form>
            </div>
            </>
        }
        </>
    )
}
export default MantAgency;